var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9839 0.109558L8.98389 0.109558C7.51722 0.109558 6.31722 1.30956 6.31722 2.77622L6.31722 18.7762C6.31722 20.2429 7.51722 21.4429 8.98389 21.4429H20.9839C22.4506 21.4429 23.6506 20.2429 23.6506 18.7762L23.6506 2.77622C23.6506 1.30956 22.4506 0.109558 20.9839 0.109558ZM20.9839 18.7762H8.98389L8.98389 2.77622L20.9839 2.77622L20.9839 18.7762ZM0.983887 17.4429L0.983887 14.7762H3.65055L3.65055 17.4429H0.983887ZM0.983887 10.1096H3.65055L3.65055 12.7762H0.983887L0.983887 10.1096ZM10.3172 24.1096H12.9839L12.9839 26.7762H10.3172L10.3172 24.1096ZM0.983887 22.1096L0.983887 19.4429H3.65055L3.65055 22.1096H0.983887ZM3.65055 26.7762C2.18389 26.7762 0.983887 25.5762 0.983887 24.1096H3.65055L3.65055 26.7762ZM8.31722 26.7762L5.65055 26.7762V24.1096L8.31722 24.1096V26.7762ZM14.9839 26.7762L14.9839 24.1096H17.6506C17.6506 25.5762 16.4506 26.7762 14.9839 26.7762ZM3.65055 5.44289L3.65055 8.10956H0.983887C0.983887 6.64289 2.18389 5.44289 3.65055 5.44289Z",
    fill: "#1F6BEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.25c45bca.svg";
export { ForwardRef as ReactComponent };